import React from 'react'
import styles from './UIGameBottomPortrait.module.scss'
import {UIGameTradeCreator} from '../UIGameTradeCreator/UIGameTradeCreator'
import {UIGameActionButtonContainer} from '../UIGameActionButtonsContainer'
import {useGameStore} from '../../store/GameStoreContext'
import {UIGameActionBoxContainer} from '../UIGameActionBox/UIGameActionBoxContainer'
import {useIsReplay} from '../../store/selectors/useIsReplay'
import clsx from 'clsx'
import {UIGameHelpOpenChatLogsButton} from '../UIGameHelpButtons/UIGameHelpChatLogsButton/UIGameHelpChatLogsButton'
import {UIGameFeedsPortrait, UIGameFeedsPortraitVisibility} from '../UIGameFeeds/UIGameFeedsPortrait'
import {UIGameReplayControlsContainer} from '../UIGameReplayControls/UIGameReplayControlsContainer'
import {UIGameDiceGroupContainer} from '../../common/UIGameDiceGroup/UIGameDiceGroupContainer'

interface UIGameBottomPortraitProps {
    feedsPortraitVisibility: UIGameFeedsPortraitVisibility
    setFeedsPortraitVisibility: (visibility: UIGameFeedsPortraitVisibility) => void
    onClickLog: (logIndex: number) => void
    onSendChat: (message: string) => void
}

export const UIGameBottomPortrait = ({
    feedsPortraitVisibility,
    setFeedsPortraitVisibility,
    onClickLog,
    onSendChat,
}: UIGameBottomPortraitProps) => {
    const myColor = useGameStore((state) => state.myColor)
    const isShowTradePanel = useGameStore((state) => state.gameTrade.isShowTradePanel)
    const actionBoxType = useGameStore((state) => state.actionBox.actionBoxData?.type)
    const isReplay = useIsReplay()
    const isMyColorSpectator = useGameStore((state) => state.isMyColorSpectator)
    const isActionBoxOpening = actionBoxType != null
    const isPopupShowing = isShowTradePanel || isActionBoxOpening

    return <div className={clsx(styles.bottomContainerPortrait, {
        [styles.popupShowing]: isPopupShowing || isReplay,
    })}>
        <div className={styles.actionsContainer}>
            <UIGameDiceGroupContainer
                playerColor={myColor}
                size='large'
                className={clsx(styles.diceGroup, {
                    [styles.hidden]: isPopupShowing || isReplay || isMyColorSpectator,
                })}
            />
            <UIGameActionButtonContainer
                isPortraitLayout
                className={clsx(styles.actionButtonContainer, {
                    [styles.hidden]: isPopupShowing || isReplay || isMyColorSpectator,
                })}
            />
            {feedsPortraitVisibility !== 'none' && <div className={styles.gameChatLogsContainer}>
                <UIGameFeedsPortrait
                    visibility={feedsPortraitVisibility}
                    onClickLog={onClickLog}
                    onSendChat={onSendChat} />
            </div>}
        </div>
        <div className={styles.gameHelpOpenChatLogsButtonContainer} data-game-chat-logs-container>
            <UIGameHelpOpenChatLogsButton
                feedsPortraitVisibility={feedsPortraitVisibility}
                setFeedsPortraitVisibility={setFeedsPortraitVisibility} />
        </div>
        {isActionBoxOpening && !isMyColorSpectator && <div className={styles.gameActionBox}>
            <UIGameActionBoxContainer isPortrait={true}/>
        </div>}
        {(isReplay || isMyColorSpectator) && <div className={styles.gameReplayControlsContainer}>
            <UIGameReplayControlsContainer useMinimalControls={true} disableTooltips />
        </div>}
        {isMyColorSpectator ?
            <div className={styles.gameInventorySpectatorContainer}/>
            : <UIGameTradeCreator isPortraitLayout className={styles.gameInventoryContainer}/>}
    </div>
}
